import type { LanguageTag } from '~types';
import en from './en-US/i18n_en-US_bookingpanel.json';
import pl from './pl-PL/i18n_pl-PL_bookingpanel.json';
import ro from './ro-RO/i18n_ro-RO_bookingpanel.json';
import ruKz from './ru-KZ/i18n_ru-KZ_bookingpanel.json';
import ruUa from './ru-UA/i18n_ru-UA_bookingpanel.json';
import ruUz from './ru-UZ/i18n_ru-UZ_bookingpanel.json';
import kzKz from './kz-KZ/i18n_kz-KZ_bookingpanel.json';
import ukUa from './uk-UA/i18n_uk-UA_bookingpanel.json';

export const mapLocaleToTranslations: Record<
    LanguageTag,
    Record<string, string>
> = {
    en_US: en,
    'pl-PL': pl,
    'bg-BG': en,
    'ro-RO': ro,
    'ru-KZ': ruKz,
    'kk-KZ': kzKz,
    'pt-PT': en,
    'uk-UA': ukUa,
    'ru-UA': ruUa,
    'uz-UZ': en,
    'ru-UZ': ruUz
};
